import { useEffect } from 'react';
import { canUseDOM } from '../utils/environment';
export var useEscapeHandler = function useEscapeHandler(element, handler) {
  var useCapture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  useEffect(function () {
    if (!canUseDOM() || !element) return;

    var onKeyPress = function onKeyPress(event) {
      event.key === 'Escape' && handler(event);
    };

    element.addEventListener('keydown', onKeyPress, useCapture);
    return function () {
      element.removeEventListener('keydown', onKeyPress, useCapture);
    };
  }, [element, handler, useCapture]);
};